import React from 'react'

const StartsWith = ({ property, onChange }) => {
  return (
    <div />
  )
}

export default StartsWith